import { LineChart } from '@mantine/charts';
import { RefObject } from 'react';

type NewDialogsChartProps = {
  activePages: Set<string>;
  pageIds: string[];
  historyRef: RefObject<Record<string, number[]>>;
  updateTimesRef: RefObject<number[]>;
  pageColors: Record<string, { line: string; fill: string }>;
};

export const NewDialogsChart = ({
  activePages,
  pageIds,
  historyRef,
  updateTimesRef,
  pageColors,
}: NewDialogsChartProps) => {
  const labels = updateTimesRef.current?.map((ts) => new Date(ts).toLocaleTimeString()) ?? [];

  const data =
    labels.map((label, index) => {
      const row: Record<string, string | number> = { time: label };

      pageIds.forEach((page) => {
        row[page] = historyRef.current?.[page]?.[index] ?? 0;
      });

      return row;
    }) ?? [];

  const series = pageIds
    .filter((page) => activePages.has(page))
    .map((page) => ({
      name: page,
      color: pageColors[page]?.line,
    }));

  return (
    <LineChart
      h={300}
      data={data}
      dataKey="time"
      series={series}
      withDots={true}
      withLegend={false}
      yAxisProps={{ domain: [0, 'auto'] }}
    />
  );
};
